import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pSupervisorOrderInfo = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_order_info`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pSupervisorOrderUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();

            await axios.post(URL_API(`${servicelist.SupervisorService}p_supervisor_order_update`), body, authorization).then((res) => {
                resolve(res);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const getipAddress = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.get("https://geolocation-db.com/json/").then((res) => {
                resolve(res.data.IPv4);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
